/**
 * Catalog of prompts that open by themselves after login.
 * Shop queue and admin list both import this. A new on-login prompt is added here;
 * it then shows in admin at defaultSort until someone saves an order.
 * Page modals (sell, child edit, order-page rating, cookie bar) are not entries.
 */
export const LOGIN_PROMPTS = [
    {
        id: 'home-tour',
        label: 'Home tour',
        description: 'Coachmarks on the home page until the shopper finishes or skips them.',
        defaultSort: 10,
    },
    {
        id: 'child-measurements',
        label: 'Child measurements',
        description: 'Asks whether the suggested height and weight still fit a child.',
        defaultSort: 20,
    },
    {
        id: 'mypetito-nudge',
        label: 'My Petito nudge',
        description: 'Asks a shopper with no child to set up My Petito.',
        defaultSort: 30,
    },
    {
        id: 'rating',
        label: 'Rate an order',
        description: 'Asks for a rating after delivery. Each order still uses this one row, with the gap between them.',
        defaultSort: 40,
    },
] as const;

export type LoginPromptId = (typeof LOGIN_PROMPTS)[number]['id'];

export function isLoginPromptId(id: string): id is LoginPromptId {
    return LOGIN_PROMPTS.some((prompt) => prompt.id === id);
}
